<span class="jt-autocomplete">
  <input #input
    [(ngModel)]="userInput"
    (ngModelChange)="onUserInputModelChange()"
    [typeaheadAsync]="isAsync"
    [typeahead]="typeaheadDataSource"
    [typeaheadScrollable]="true"
    [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
    [typeaheadOptionsLimit]="typeaheadOptionsLimit"
    (typeaheadLoading)="changeTypeaheadLoading($event)"
    (typeaheadOnSelect)="typeaheadOnSelect($event)"
    [typeaheadOptionField]="optionTextField"
    [typeaheadItemTemplate]="itemTemplate"
    [attr.placeholder]="autoCompleteConfig.placeholder"
    [attr.name]="autoCompleteConfig.nameAttribute"
    [attr.required]="autoCompleteConfig.required"
    class="form-control jt-autocomplete__input"
    autocomplete="off"
    type="text"
    (change)="onChange()">

  <ng-template #itemTemplate let-model="item" let-index="index">
    <div class="jt-autocomplete__option">
      {{model[optionTextField]}}
    </div>
  </ng-template>

  <button class="jt-autocomplete__action" type="button" [attr.aria-label]="showClearButton ? 'Clear' : 'Search'">
    @if (typeaheadLoading) {
      <img class="jt-autocomplete__loader" src="assets/circle-loading-animation.gif">
    }
    @if (!typeaheadLoading && showClearButton) {
      <svg class="jt-autocomplete__icon jt-autocomplete__icon--clear" (click)="clearValue()">
        <use xlink:href="assets/NewJT7/img/sprite.svg#button-close"></use>
      </svg>
    }
    @if (!typeaheadLoading && showSearchButton) {
      <span class="jt-autocomplete__search-icon" (click)="onSearchClick()">
        <app-svg-icon [type]="'Search'" [className]="'icon'"></app-svg-icon>
      </span>
    }
  </button>
</span>
